import { getSchedulerLocalization } from "../utils/getSchedulerLocalization.mjs";
const zhCNDialog = {
  // EventDialog
  // colorPickerLabel: 'Event color',
  // dateTimeSectionLabel: 'Date & time',
  // resourceColorSectionLabel: 'Resource & color',
  // allDayLabel: 'All Day',
  // closeButtonAriaLabel: 'Close',
  // closeButtonLabel: 'Close',
  // deleteEvent: 'Delete event',
  // descriptionLabel: 'Description',
  // endDateLabel: 'End date',
  // endTimeLabel: 'End time',
  // eventTitleAriaLabel: 'Event title',
  // generalTabLabel: 'General',
  // labelNoResource: 'No resource',
  // labelInvalidResource: 'Invalid resource',
  // recurrenceLabel: 'Recurrence',
  // recurrenceNoRepeat: "Don't repeat",
  // recurrenceCustomRepeat: 'Custom repeat rule',
  // recurrenceDailyPresetLabel: 'Repeats daily',
  // recurrenceDailyFrequencyLabel: 'days',
  // recurrenceEndsLabel: 'Ends',
  // recurrenceEndsAfterLabel: 'After',
  // recurrenceEndsNeverLabel: 'Never',
  // recurrenceEndsUntilLabel: 'Until',
  // recurrenceEndsTimesLabel: 'times',
  // recurrenceEveryLabel: 'Every',
  // recurrenceRepeatLabel: 'Repeat',
  // recurrenceTabLabel: 'Recurrence',
  // recurrenceMainSelectCustomLabel: 'Recurrence',
  // recurrenceWeeklyFrequencyLabel: 'weeks',
  // recurrenceWeeklyPresetLabel: weekday => `Repeats weekly on ${weekday}`,
  // recurrenceMonthlyFrequencyLabel: 'months',
  // recurrenceMonthlyDayOfMonthLabel: dayNumber => `Day ${dayNumber}`,
  // recurrenceMonthlyLastWeekAriaLabel: weekDay => `${weekDay} of the last week of the month`,
  // recurrenceMonthlyLastWeekLabel: weekDay => `${weekDay} last week`,
  // recurrenceMonthlyPresetLabel: dayNumber => `Repeats monthly on day ${dayNumber}`,
  // recurrenceMonthlyWeekNumberAriaLabel: (ord, weekDay) => `${weekDay} week ${ord} of the month`,
  // recurrenceMonthlyWeekNumberLabel: (ord, weekDay) => `${weekDay} week ${ord}`,
  // recurrenceWeeklyMonthlySpecificInputsLabel: 'On',
  // recurrenceYearlyFrequencyLabel: 'years',
  // recurrenceYearlyPresetLabel: date => `Repeats annually on ${date}`,
  // noResourceAriaLabel: 'No specific resource',
  // selectColorAriaLabel: color => `Select ${color} as event color`,
  // resourceLabel: 'Resource',
  // requiredResourceError: 'A resource is required.',
  // saveChanges: 'Save',
  // startDateAfterEndDateError: 'Start date/time must be before end date/time.',
  // startDateLabel: 'Start date',
  // startTimeLabel: 'Start time',
  // RecurringScopeDialog
  // all: 'All events',
  // cancel: 'Cancel',
  // confirm: 'Confirm',
  // onlyThis: 'Only this event',
  // radioGroupAriaLabel: 'Editing recurring events scope',
  // thisAndFollowing: 'This and following events',
  // title: 'Apply this change to:',
};
const zhCNCalendar = {
  // ResourcesTree
  // resourcesLabel: 'Resources',
  // ViewSwitcher
  // agenda: 'Agenda',
  // day: 'Day',
  // month: 'Month',
  // other: 'Other',
  // today: 'Today',
  // week: 'Week',
  // time: 'Time',
  // days: 'Days',
  // months: 'Months',
  // weeks: 'Weeks',
  // years: 'Years',
  // DateNavigator
  // closeSidePanel: 'Close side panel',
  // openSidePanel: 'Open side panel',
  // Preferences menu
  // amPm12h: '12-hour (1:00PM)',
  // hour24h: '24-hour (13:00)',
  // preferencesMenu: 'Settings',
  // showWeekends: 'Show weekends',
  // showEmptyDaysInAgenda: 'Show empty days',
  // showWeekNumber: 'Show week number',
  // timeFormat: 'Time format',
  // viewSpecificOptions: view => `${view} view options`,
  // startWeekOn: 'Start week on',
  // weekdaySunday: 'Sunday',
  // weekdayMonday: 'Monday',
  // weekdaySaturday: 'Saturday',
  // WeekView
  // allDay: 'All day',
  // hiddenEvents: hiddenEventsCount => `${hiddenEventsCount} more..`,
  // nextTimeSpan: timeSpan => `Next ${timeSpan}`,
  // previousTimeSpan: timeSpan => `Previous ${timeSpan}`,
  // resourceAriaLabel: resourceName => `Resource: ${resourceName}`,
  // weekAbbreviation: 'W',
  // weekNumberAriaLabel: weekNumber => `Week ${weekNumber}`,
  // EventItem
  // eventItemMultiDayLabel: endDate => `Ends ${endDate}`,
  // MiniCalendar
  // miniCalendarLabel: 'Calendar',
  // miniCalendarGoToPreviousMonth: 'Show previous month in calendar',
  // miniCalendarGoToNextMonth: 'Show next month in calendar',
  // Main calendar region
  // calendarContentAriaLabel: 'Calendar content',
  // Timeline title sub grid
  // timelineResourceTitleHeader: 'Resource title',
};
const zhCNTimeline = {
  // Timeline title sub grid
  // timelineResourceTitleHeader: 'Resource title',
};
export const zhCN = getSchedulerLocalization({
  dialog: zhCNDialog,
  calendar: zhCNCalendar,
  timeline: zhCNTimeline
});